export default __webpack_public_path__ + "static/media/ScreenShot_4.e8b76c07.jpg";